import React from 'react'
import { useTranslation } from 'react-i18next'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import i18n from '~/components/i18n'

const getTableColumns = () => [
  {
    name: i18n.t('Name'),
    key: 'name'
  },
  {
    name: i18n.t('Abbreviation'),
    key: 'abbreviation'
  },
  {
    name: i18n.t('Description'),
    key: 'description'
  },
  {
    name: i18n.t('Color'),
    key: 'color',
    type: 'color-label'
  }
];

const FormsOfHusbandry: React.FC = () => {
  const { t } = useTranslation()

  const {
    isLoading: isBusyData,
    data: husbandryForms
  } = DairyQuery.getHusbandryForms()

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={getTableColumns()}
      rows={husbandryForms || []}
      total={husbandryForms?.length || 0}
      removePagination
    />
  }

  return <Layout
    title={t('Forms of husbandry')}
    isBusy={isBusyData}
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    useSpinner
  >
    {husbandryForms && renderTable()}
  </Layout>
}
export default FormsOfHusbandry